/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Err_Duplicate_UsernameInputs */

const vi_user_err_duplicate_username = /** @type {(inputs: User_Err_Duplicate_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên đăng nhập đã tồn tại`)
};

/**

* @param {User_Err_Duplicate_UsernameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_err_duplicate_username = /** @type {((inputs?: User_Err_Duplicate_UsernameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Err_Duplicate_UsernameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_err_duplicate_username(inputs)
});